import generalReducer from './reducers'

export { default as generalActions } from './actions'
export { default as generalSagas } from './sagas'

export default generalReducer